import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { convertScanners, Scanner, ScannerSchema } from "../types/scanner";
import { apiGet, apiPost } from "./query";
import { STALE_TIME } from "../types/staleTime";

const ENDPOINT = "scanner";

export const useScannerGetAll = () => {
  return useQuery({
    queryKey: ["scanner"],
    queryFn: async () => (await apiGet(ENDPOINT, convertScanners)).data,
    staleTime: STALE_TIME.MIN_30,
    throwOnError: true,
  });
};

export const useScannerUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (scanner: ScannerSchema) => apiPost(`${ENDPOINT}/${scanner.id}`, scanner),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["scanner"] }),
    throwOnError: true,
  })
}

export const useScannerLight = () => {
  return useMutation({
    mutationFn: ({ id }: Pick<Scanner, "id">) => apiPost(`${ENDPOINT}/light/${id}`),
    throwOnError: true,
  })
}
